<template>
  <div class="min-h-screen bg-gray-50">
    <CheckoutLanding />
  </div>
</template>

<script setup lang="ts">
import CheckoutLanding from './components/CheckoutLanding.vue';
</script>
